export default __webpack_public_path__ + "static/media/backgroundlooprev.d97e4b52.mp4";